import { colors } from '@alixpartners/ui-components';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const CarouselWrapper = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
`;

export const CarouselContainer = styled.div`
	width: 96%;
	position: relative;
`;

export const CarouselContent = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	gap: 15px;
	animation: ${fadeIn} 0.5s ease-in-out;
`;

export const ArticleWrapper = styled.div`
	width: 32%;
	box-shadow: 0px 6px 24px 0px #b7b7b7;
	border-radius: 10px; /* Add border radius here */
	overflow: hidden; /* Ensure overflow is hidden */
	&:hover {
		transform: translateY(-5px);
		transition: transform 0.3s ease, box-shadow 0.3s ease;
	}
`;

export const CarouselButton = styled.button`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	color: ${colors.grey6};
	border: none;
	padding: 5px 10px;
	border-radius: 15px;
	cursor: pointer;
	z-index: 10;
	${({ left }) => (left ? `right: 100%;` : `left: 100%;`)};
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

	&:hover {
		background-color: ${({ disabled }) =>
			disabled ? 'rgba(0, 0, 0, 0.3)' : 'rgba(0, 0, 0, 0.5)'};
		color: ${colors.white};
		transition: all 0.3s ease-in-out;
	}
`;
